<template>
  <div v-show="value" class="c-drawer" @click.self="onBackdropClick">
    <transition
      :leave-active-class="`c-drawer__content__align--${align}-leave`"
    >
      <div
        class="c-drawer__content"
        :class="`c-drawer__content__align--${align} ${
          inside ? 'c-drawer__inside' : ''
        } c-drawer__content__size--${size}`"
        @click.stop
      >
        <header class="c-drawer__content__header">
          <h4>{{ title }}</h4>
          <i
            @click="$emit('input', false)"
            class="c-drawer__content__header__icon icofont-close"
          ></i>
        </header>
        <div class="c-drawer__content__content">
          <slot></slot>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: false,
    },
    inside: {
      default: false,
      type: Boolean,
    },
    persistent: {
      default: false,
      type: Boolean,
    },
    align: {
      default: "right",
    },
    title: {
      default: "",
    },
    size: {
      default: "md",
    },
  },
  methods: {
    onBackdropClick() {
      if (this.persistent) return;
      this.$emit("input", false);
    },
  },
};
</script>

<style></style>
